// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/production/work-oder/${file}.vue`);

export default [
    {
        path: "/work-order",
        name: "work-order",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrder",
        },
        components: {
            content: lazyLoad("work-order-list"),
        },
    },
    {
        path: "/work-order-draft",
        name: "work-order-draft-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrder",
        },
        components: {
            content: lazyLoad("work-order-draft-list"),
        },
    },
    {
        path: "/work-order-open",
        name: "work-order-open-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrder",
        },
        components: {
            content: lazyLoad("work-order-open-list"),
        },
    },
    {
        path: "/work-order-completed",
        name: "work-order-completed-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrder",
        },
        components: {
            content: lazyLoad("work-order-completed-list"),
        },
    },
    {
        path: "/releases-list",
        name: "releases-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrder",
        },
        components: {
            content: lazyLoad("releases-list")
        }
    },
    {
        path: "/work-order-material-issues",
        name: "work-order-material-issues",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrderMaterialIssue",
        },
        components: {
            content: lazyLoad("material-issues-list"),
        },
    },
    // Work Order Bulk Update Routes
    {
        path: "/work-order-bulk-update",
        name: "work-order-bulk-update",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BulkWOUpdate",
        },
        components: {
            content: lazyLoad("work-order-bulk-update-list"),
        },
    },
    {
        path: "/work-order-bulk-update/create",
        name: "work-order-bulk-update-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BulkWOUpdate",
            mode: "create",
        },
        components: {
            content: lazyLoad("work-order-bulk-update"),
        },
    },
    {
        path: "/work-order-bulk-update/edit/:id",
        name: "work-order-bulk-update-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BulkWOUpdate",
            mode: "edit",
        },
        components: {
            content: lazyLoad("work-order-bulk-update"),
        },
    },
    {
        path: "/work-order-bulk-update/review/:id",
        name: "work-order-bulk-update-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BulkWOUpdate",
            mode: "review",
        },
        components: {
            content: lazyLoad("work-order-bulk-update"),
        },
    },
];